import { render, staticRenderFns } from "./SubEntityGroup.vue?vue&type=template&id=2cbc7ce2&scoped=true"
import script from "./SubEntityGroup.vue?vue&type=script&lang=js"
export * from "./SubEntityGroup.vue?vue&type=script&lang=js"
import style0 from "./SubEntityGroup.vue?vue&type=style&index=0&id=2cbc7ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc7ce2",
  null
  
)

export default component.exports